<template>
  <div class="users-picker">
    <div class="users-picker__userslist">
      <label v-for="user in users" :key="user.id" class="users-picker__user">
        <input-checkbox
          :value="selectedUserIds.includes(user.id)"
          @update:value="updateUser(user, $event)"
        />
        <user-avatar :user="user" />
        <span>{{ user.name }}</span>
        <span>{{ user.email }}</span>
      </label>
    </div>
  </div>
</template>

<script setup lang="ts">
import InputCheckbox from "@core/input/InputCheckbox.vue";
import UserAvatar from "./UserAvatar.vue";

type User = {
  id: number;
  name: string | null;
  email: string | null;
};

defineProps<{
  users: User[];
  selectedUserIds: number[];
}>();

const emit = defineEmits(["check-user", "uncheck-user"]);

function updateUser(user: User, value: boolean) {
  if (value) {
    emit("check-user", user);
  } else {
    emit("uncheck-user", user);
  }
}
</script>

<style lang="scss">
.users-picker {
  overflow: auto;
  padding: 0.5rem;
  margin: 0 -0.5rem;
  max-height: 15rem;

  // scrollgradient
  background: linear-gradient(
      var(--color-background-deep) 33%,
      rgba(255, 255, 255, 0)
    ),
    linear-gradient(rgba(255, 255, 255, 0), var(--color-background-deep) 66%) 0
      100%,
    radial-gradient(
      farthest-side at 50% 0,
      rgba(147, 160, 169, 0.2),
      rgba(0, 0, 0, 0)
    ),
    radial-gradient(
        farthest-side at 50% 100%,
        rgba(147, 160, 169, 0.2),
        rgba(0, 0, 0, 0)
      )
      0 100%;
  background-color: var(--color-background-deep);
  background-repeat: no-repeat;
  background-attachment: local, local, scroll, scroll;
  background-size: 100% 21px, 100% 21px, 100% 7px, 100% 7px;

  &__userslist {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }
  &__user {
    display: grid;
    grid-template-columns: 2rem 2.5rem 1fr 1fr;
    box-shadow: 0 2px 5px var(--color-shadow-1);
    background-color: var(--color-background-close);
    padding: 0.25rem 0.5rem;
    border-radius: 5px;
    align-items: center;
    gap: 0.5rem;
    &:hover {
      background-color: var(--color-background-close-hover);
    }
  }
}
</style>
